import React from 'react';

const NavItem = ({ id, icon, label, active, onClick }) => (
  <div
    className={`nav-item ${active === id ? 'active' : ''}`}
    onClick={() => onClick(id)}
    data-testid={`nav-item-${id}`}
  >
    <span className="nav-icon">{icon}</span>
    <span>{label}</span>
  </div>
);

export default NavItem;
